import { FormGroup, makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';
import CheckBox from '../../../UI/inputs/CheckBox';
import usePermissions from '../../../../hooks/usePermissions';
import { PropTypes } from 'prop-types';

const styles = makeStyles({
    row: {
        display: 'flex',
        alignItems: 'center'
    },
    icon: {
        width: '17px',
        height: '17px',
        borderRadius: '50%',
        border: 'solid 1.5px rgb(187 ,187 ,187)',
        color: 'rgb(187,187,187)',
        marginInlineStart: '15px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '12px',
        cursor: 'pointer',
        paddingTop: '1px'
    },
    tooltip: {
        background: '#ebf0ff',
        color: 'black',
        margin: 0,
        fontSize: '13px',
        boxShadow: '0 2px 4px 0 rgba(84, 94, 102, 0.12)',
        width: '190px',
        padding: '12px',
        textAlign: 'start',
        unicodeBidi: 'plaintext'
    },
    arrow: {
        color: '#ebf0ff'
    }
});
const PermissionsList = ({ value, setFieldValue, disabled, isDelegate = false, ...props }) => {
    const { permissions } = usePermissions();
    const classes = styles();
    const permValue = value?.permissions;
    const disableList = Object.keys(permValue)
        .filter((item) => !item.startsWith('delegate') && !permValue[item])
        .map((item) => `delegate_${item}`);

    return (
        <div>
            <FormGroup>
                {permissions.map((item) => (
                    <div key={item.id} className={classes.row}>
                        <CheckBox
                            disabled={disabled && disableList.includes(`delegate_${item.name}`)}
                            value={permValue?.[isDelegate ? `delegate_${item.name}` : item.name]}
                            name={isDelegate ? `delegate_${item.name}` : item.name}
                            title={item.title}
                            handleChange={({ target: { value } }) => {
                                setFieldValue(`permissions.${value}`, !permValue?.[value]);
                                if (permValue[value] && permValue[`delegate_${value}`]) {
                                    setFieldValue(`permissions.delegate_${value}`, false);
                                }
                            }}
                            {...props}
                        />
                        {!isDelegate && (
                            <Tooltip
                                title={item.description}
                                arrow
                                placement="top"
                                color="blue"
                                classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                            >
                                <div className={classes.icon}>i</div>
                            </Tooltip>
                        )}
                    </div>
                ))}
            </FormGroup>
        </div>
    );
};

PermissionsList.propTypes = {
    value: PropTypes.object,
    setFieldValue: PropTypes.function,
    disabled: PropTypes.bool,
    isDelegate: PropTypes.bool
};

export default PermissionsList;
